module.exports = __webpack_public_path__ + "static/media/exclusive_without_num-3.61ba7996.png";